(() => {

    let posts = document.querySelectorAll('.socials-feed-eleven .social-post');

    // // handle opening of video
    // posts.forEach(post => {
    //     post.addEventListener('click', function() {

    //         // if not playing already
    //         if (!post.classList.contains('active')) {
    //             // pause all other posts
    //             posts.forEach(post => {
    //                 post.querySelector('video') ? post.querySelector('video').pause() : false;
    //                 post.classList.remove('active');
    //             });
    //             // play video on this clicked post
    //             this.querySelector('video').play();
    //             this.classList.add('active');
    //         }

    //     });
    // });


    // // handle closing of video
    // posts.forEach(post => {
    //     post.querySelector('video')?.addEventListener('pause', function() {
    //         let parent = this.closest('.social-post');
    //         parent.classList.remove('active');
    //     })
    // })

})();